import React, { useEffect, useState } from "react";
import { Card, Row, Col, Badge } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import PageLayout from "../../../layouts/PageLayout";

export default function ViewTraining() {
  const { id } = useParams();

  const [training, setTraining] = useState(null);

  const AuthToken = localStorage.getItem("AuthUser");
  axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;

  useEffect(() => {
    fetchTraining();
  }, []);

  const fetchTraining = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/vocational-training/${id}`
      );

      setTraining(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  if (!training) {
    return (
      <PageLayout>
        <Card>
          <Card.Body>Loading...</Card.Body>
        </Card>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Card>
        <Card.Header>
          <h4>Vocational Training Details</h4>
        </Card.Header>

        <Card.Body>
          <Row>
            <Col md={6}>
              <p>
                <strong>Family:</strong>{" "}
                {training.family?.f_number}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Student:</strong>{" "}
                {training.student_name}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Relation:</strong>{" "}
                {training.relation}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Institute:</strong>{" "}
                {training.institute?.name}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Training:</strong>{" "}
                {training.course?.course_name}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Duration:</strong>{" "}
                {training.duration}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Fee:</strong>{" "}
                Rs. {training.fee}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Status:</strong>{" "}
                <Badge bg="success">
                  {training.progress}
                </Badge>
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>Start Date:</strong>{" "}
                {training.start_date}
              </p>
            </Col>

            <Col md={6}>
              <p>
                <strong>End Date:</strong>{" "}
                {training.end_date || "-"}
              </p>
            </Col>

            <Col md={12}>
              <p>
                <strong>Story:</strong>
              </p>
              <div className="border p-3 rounded">
                {training.story}
              </div>
            </Col>

            {training.before_image && (
              <Col md={6} className="mt-4">
                <h6>Before Image</h6>
                <img
                  src={`${process.env.REACT_APP_IMG_URL}/${training.before_image}`}
                  alt="Before"
                  className="img-fluid rounded"
                />
              </Col>
            )}

            {training.after_image && (
              <Col md={6} className="mt-4">
                <h6>After Image</h6>
                <img
                  src={`${process.env.REACT_APP_IMG_URL}/${training.after_image}`}
                  alt="After"
                  className="img-fluid rounded"
                />
              </Col>
            )}

            {training.fee_receipt && (
              <Col md={12} className="mt-4">
                <a
                  href={`${process.env.REACT_APP_IMG_URL}/${training.fee_receipt}`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn btn-primary"
                >
                  View Fee Receipt
                </a>
              </Col>
            )}

            {training.video && (
              <Col md={12} className="mt-4">
                <h6>Training Video</h6>
                <video
                  width="100%"
                  controls
                >
                  <source
                    src={`${process.env.REACT_APP_IMG_URL}/${training.video}`}
                    type="video/mp4"
                  />
                </video>
              </Col>
            )}
          </Row>
        </Card.Body>
      </Card>
    </PageLayout>
  );
}